import request from "@/utils/request";
import baseUrl from "@/api/baseUrl";

const basePath = `${baseUrl.vip}/coop`;

export default class Coop {
  static list(params = {}) {
    return request.get(`${basePath}/list`, params);
  }

  static getInfo(id) {
    return request.get(`${basePath}/getInfo/${id}`);
  }

  static add(data = {}) {
    return request.post(`${basePath}/add`, data);
  }

  static edit(data = {}) {
    return request.put(`${basePath}/edit`, data);
  }

  static remove(ids) {
    return request.delete(`${basePath}/${ids}`);
  }
}
